import Taskbar from '../components/Taskbar';
import VisionDropdownNav from '../components/VisionDropdownNav';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ImageSlider from '../components/ImageSlider';
//import TwoColumnLayout from "../components/TwoColumnLayout";
//import AppSidebar from "../components/AppSidebar";


const WatchTower = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id = hash.replace("#", "");
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, [hash]);

  const slides = [
    {
      image: "images/watchTowerImageSlider/watchImageSlider1.jpg",
      title: "The Vision Of The Saints And The Beast By Prophet Kevin N",
      description: "On the dawn of the set day, I was caught up in the...",
      linkTo: "/watchtower",
      scrollToId: "covenant-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider2.jpg",
      title: "The Vision Of the Lion Of Judah By Prophet Kevin N",
      description: "While in prayers, the Heavens were opened upon me and my spirit was caught up in the visions of God...",
      linkTo: "/watchtower",
      scrollToId: "lion-judah-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider3.jpg",
      title: "The Vision About Pornography By Prophet Kevin N",
      description: "While in the place of prayer the Lord spoke to me thus ; My Prophet arise and cry out against the Spirit of Jezebel...",
      linkTo: "/watchtower",
      scrollToId: "pornography-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider4.jpg",
      title: "The Vision Of The Gathering Of The Heavenly Army By Prophet Kevin N",
      description: "I was caught up in the visions of God, and I saw a great gathering of beings, both earthly and heavenly...",
      linkTo: "/watchtower",
      scrollToId: "gathering-army-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider5.jpg",
      title: "The Vision Of The Invation Of The Children Of God By Prophet Kevin N",
      description: "This Morning in-between 3 am to 5 am I saw a vision from the Lord, that unveiled to me the plans of the kingdom of Darkness against the Earth...",
      linkTo: "/watchtower",
      scrollToId: "invasion-children-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider6.jpg",
      title: "The Vision Of The Great Banquet By Prophet Kevin N",
      description: "Today I was caught up in the spirit and, the Lord said to me; Now the Hour has come to gather all men to Me...",
      linkTo: "/watchtower",
      scrollToId: "great-banquet-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider7.jpg",
      title: "The Vision About The Demonic Agenda To Corrupt The Worship Ministry By Prophet Kevin N",
      description: "While I was waiting on the Lord, to know His mind for this time and season, His Word came to me thus...",
      linkTo: "/watchtower",
      scrollToId: "demonic-agenda-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider8.jpg",
      title: "The Vision Of The Mountain Of Transfiguration By Prophet Kevin N",
      description: "While waiting on the Lord and seeking His face for the New Year, I was privileged through the Grace of God to be carried into the...",
      linkTo: "/watchtower",
      scrollToId: "mountain-of-transfiguration-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider9.jpg",
      title: "The Vision Of The Lord Jesus And His Message To The World By Prophet Kevin N",
      description: "By the privilege of Grace, I was carried by the Spirit of God into the visions of God and this is what I saw...",
      linkTo: "/watchtower",
      scrollToId: "lord-jesus-message-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider10.jpg",
      title: "The Vision Of The Lord Jesus Grieved By Prophet Kevin N",
      description: "On the morning of Tuesday, December 26th, I had a deeply troubling vision of the Lord Jesus...",
      linkTo: "/watchtower",
      scrollToId: "lord-jesus-grieved-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider11.jpg",
      title: "The Vision Of The Palm Branches By Prophet Kevin N",
      description: "I was caught up in the visions of God where we were gathered in the assembly of the saints...",
      linkTo: "/watchtower",
      scrollToId: "vision-of-the-palm-branches",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider12.jpg",
      title: "The Vision Of The Evil Birds By Prophet Kevin N",
      description: "On Saturday 27th of April around 2am earthly time, after praying and calling upon the Lord to cause His face to shine upon His people...",
      linkTo: "/watchtower",
      scrollToId: "evil-birds-cover-light-heaven",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider13.jpg",
      title: "An Encounter With Moses And Samuel By Prophet Kevin N",
      description: "On the night of the 18th of March, I had a strange vision in which I saw mysteries and heard unspeakable words, which are...",
      linkTo: "/watchtower",
      scrollToId: "encounter-moses-samuel-book-generations",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider14.jpg",
      title: "My Visit To Heaven By Prophet Kevin N",
      description: "On this ordained night of visitation, I felt a sudden heaviness and I fell asleep as I closed my eyes. Immediately...",
      linkTo: "/watchtower",
      scrollToId: "my-visit-to-heaven-full-version",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider15.jpg",
      title: "The Vision Of The Heavenly Market By Prophet Kevin N",
      description: "This vision came to me in the morning of the 23rd of Nissi (April), after intercession for the Saints, Pastors, and churches...",
      linkTo: "/watchtower",
      scrollToId: "the-vision-of-the-heavenly-market",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider16.jpg",
      title: "Prophecy About The 3 Evil Beings Released Against The Church By Prophet Kevin N",
      description: "A vision the Lord gave me while praying and seeking His face concerning the Church and the nations...",
      linkTo: "/watchtower",
      scrollToId: "three-evil-beings-prophecy",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider17.jpg",
      title: "The Vision Of The Sheep That Mounted Up With Wings By Prophet Kevin N",
      description: "This is the third vision in the morning of the 23rd of Nissi (April)...",
      linkTo: "/watchtower",
      scrollToId: "sheep-with-eagle-wings",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider18.jpg",
      title: "The Vision Of The Great Fruitful Tree By Prophet kevin N",
      description: "I was caught up in the Vision of God, and I saw a Mystery in the Realm of The Spirit...",
      linkTo: "/watchtower",
      scrollToId: "fruitful-tree-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider19.jpg",
      title: "The Vision Of The Sheep, The Evil Birds etc By Prophet Kevin N",
      description: "My spirit was caught up into the visions of God and I saw a great and terrible oracle from the Most High pertaining to the affairs of Men!...",
      linkTo: "/watchtower",
      scrollToId: "sheep-evil-birds-wild-cows-lion",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider20.jpg",
      title: "The Vision Of The Cloud Of Witnesses By Prophet Kevin N",
      description: "The visions of God came upon me while I laid in my bed and thoughts about heavenly things flooded my mind...",
      linkTo: "/watchtower",
      scrollToId: "cloud-of-witnesses",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider21.jpg",
      title: "The Vision About The Northwest And Southwest Region Of Cameroon By Prophet Kevin N",
      description: "The fire in The Northwest and Southwest Regions of Cameroon has been quenched in the Realm of the Spirit...",
      linkTo: "/watchtower",
      scrollToId: "visions-2024-point-2",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider22.jpg",
      title: "The Vision Of 3 Rams Fighting By Prophet Kevin N",
      description: "I saw in the Visions of God 3 rams fighting...",
      linkTo: "/watchtower",
      scrollToId: "visions-2024-point-3",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider23.jpg",
      title: "The Agriculture Sector Will Be The Strength Of The Economy By Prophet Kevin N",
      description: "The agricultural sector will be the strength of the economy and a lot of...",
      linkTo: "/watchtower",
      scrollToId: "visions-2024-point-4",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider24.jpg",
      title: "The Vision Of The Seraphim And The Cherubims By Prophet Kevin N",
      description: "The hand of the Lord carried me in the spirit into the visions of God, and I saw the agenda of the evil one...",
      linkTo: "/watchtower",
      scrollToId: "seraphim-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider25.jpg",
      title: "The Vision About The Dark Beast In The Cloud That Gave Birth To Serpents By Prophet Kevin N",
      description: "On Saturday, the 10th of February 2024, around 6:30am after seeking the Lord, I was caught up in the spirit...",
      linkTo: "/watchtower",
      scrollToId: "dark-beast-vision",
    },
  ];

  return (
    <div className='bg-bg min-h-screen overflow-hidden'>
      <Taskbar />
      <VisionDropdownNav />

      <div className='max-[942px]:pt-12 min-[942px]:mt-[51px]'>
        <div className=" text-text mx-auto max-w-[1400px] bg-bg">
          <div className="flex max-[942px]:flex-col min-[942px]:flex-row gap-1">

            {/* LEFT EXPLORER */}
            <aside
              className="
             hidden min-[942px]:block
            w-[500px]
            sticky top-[70px]
            h-[calc(100vh-70px)]
            overflow-y-auto
            border-r border-gray-200
            pr-4
          "
            >
              <div>
                <ImageSlider slides={slides} />
              </div>
              {/* <VisionExplorer /> */}
              <h3 className='text-xl font-bold'>Exploring center coming soon...</h3>
              
            </aside>

            {/* RIGHT CONTENT */}
            <main
              className="
            flex-1
            min-[942px]:h-[calc(100vh-70px)]
            min-[942px]:overflow-y-auto
            scroll-smooth
          "
            >
              <div>
                <ImageSlider slides={slides} />
              </div>
              <section
                aria-label="Vision of the Saints"
                style={{ animation: "fadeIn 1.8s ease forwards" }}
              >

                {/* Vision 1 */}
                <VisionSection
                  id="covenant-vision"
                  title="The Vision of the Saints, The Beasts, and the Blood from the Right Hand of the Lord Jesus!"
                  titleColor="text-primary"
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider1.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <p className="mb-6 leading-relaxed text-lg italic">
                    On the dawn of the set day, I was caught up in the Visions of God and I received an Oracle from the Spirit of God for the Comfort and Victory of the Saints.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    I saw a vision where a group of brethren were on a journey to a glorious city. The way to the city was full of Light, but on both sides of the way there was a great cloud of Darkness. This journey was plagued with all forms of adversities and hardships to try them and prove their Faith in the Lord their God. Yet, no matter the afflictions, they strengthened themselves in the knowledge that the Lord God is their Rewarder and encouraged one another to despise the pain and shame of their journey so they may be found worthy to obtain the crown of glory from the hands of the Great King!
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    At a certain point of the journey, the bread and water we had in our bags got finished. We began to be in want, our strength diminished on account of thirst and hunger, and some of the brethren began complaining bitterly. While we argued, we saw a pathway that deviated from the Main Way. This path led into the darkness toward a small city. Some brethren suggested going there to find food and drink.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    While some refused, others insisted. Those who went into the city found women selling cakes, which were freely given to them. The brethren returned and shared what they received. More went in and also received cakes, and when they asked for water, the women gave them wine instead. Some of the brethren partook, but others refused to eat the cake or drink the wine.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    As the journey continued, the eyes of those who drank the wine became heavy, and they began sleeping on the way. Suddenly, ravenous beasts and wolves emerged from the forest and began devouring them. A fierce battle broke out. Those who had drunk the wine were overcome, but the others fought and prevailed, and the beasts fled back into the darkness.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The brethren wept for those lost and continued. Then something strange happened: those who had eaten the cakes began walking off the path, some into the darkness, others turning back, and some began cursing the others. They behaved contrary to their will, and the faithful brethren wondered why.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The Lord opened the eyes of the faithful, and they saw the cakes had become WORMS within the others—black, with fangs like scorpions—gripping their hearts. The women who gave the cakes were Mistresses of these Worms. When they spoke, the worms compelled obedience from the afflicted brethren.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The faithful began to pray, and the Lightning of God struck the worms, killing them. They came out of the brethren’s mouths like white gum. Seeing this, the women transformed into beasts. Fierce men joined them, and a greater battle erupted. They brought Beasts, Serpents, and Birds.
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border text-add italic text-xl">
                    The saints prayed. Oh, they prayed and called upon the name of the Lord their God, and He answered them!
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    Heaven released Lightning that struck the beasts, but more came. The women spoke curses that flew like arrows. The saints kept praying—every word like a flaming sword!
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The battle intensified, and the saints grew weary. They cried out to the Lord Jesus. Then it happened—Oh, an indescribable glory! A bright light appeared, illuminating the whole place.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    In the Light was a Cloud, and in the Cloud stood the Lord Jesus! He was on a transparent, fiery Rock. Clothed in white, with a Red Sash, He opened His right hand. From the wound in His palm, a drop of blood fell to the earth—causing earthquakes, thunders, and lightning!
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border text-add italic text-xl">
                    All the beasts, serpents, and birds fled. Yet the fire of the Holy Presence devoured them!
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    Then the Lord strengthened the saints. Rain came from the Cloud, refreshing them. They mounted up with wings as eagles, soared high, and walked without weariness or fainting!
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The Lord disappeared, but the Cloud remained. As they rejoiced, a host of angels joined them in praise. And a voice declared:
                  </p>

                  <h2 className="text-xl text-text font-bold mb-3 pb-1">
                    "There shall be Victory and Rest on All Sides through the Blood of the Savior for they that believe!"
                  </h2>

                  <p className="mb-6 leading-relaxed text-lg">
                    Then the Spirit spoke to me and said:
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border text-add italic text-xl">
                    "Publish this Word, there shall be Victory and Rest on all sides through the Blood of the Lamb unto those that Believe!"
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    I, Kevin, the Priest of God, therefore publish this Vision that the saints may know what is happening in the Realm of the Spirit.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    All that I have written, I write before the Lord my God. For I myself was among the brethren in that vision. I testify that the Blood of the Lord Jesus is mighty on behalf of the saints.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    I urge all saints to set aside the Fourth Month of the Year (April), which is the Season of Passover in the Calendar of Zion, to place a demand on the Blood of Jesus through prayers and fasting that they may obtain victory and rest on all sides!
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Great Grace
                    <br />
                    The Priest of the Most High God !
                  </p>
                </VisionSection>


                {/* Vision 2 */}
                <VisionSection
                  id="seraphim-vision"
                  title="Vision of the SERAPHIM and the CHERUBIMS"
                  titleColor="from-teal-400 to-teal-300"
                  italicText="The hand of the Lord carried me in the spirit into the visions of God, and I saw the agenda of the evil one."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider24.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg">
                    In the visions, I saw great beasts rising from the waters in all forms. They were filled with fury and commanded to torment and tempt all who believe in the name of the Lord. Their mission was to persecute the saints and make their lives bitter through affliction.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    But as they came upon the earth, the seraphim and cherubim also descended from God's throne. The LORD Most High sent them to minister to and protect the saints in spirit, soul, and body from the dragon and his angels.
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-yellow-300 italic text-xl">
                    “The outpour of the Spirit of glory upon the saints is the Response of the Father to the spirit of persecutions the Evil one has released against the church.”
                  </blockquote>
                </VisionSection>

                <VisionSection
                  id="dark-beast-vision"
                  title="The Vision About the Dark Beast in the Clouds That Gave Birth to Serpents"
                  titleColor="from-indigo-200 to-indigo-400">
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider25.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg">
                    On Saturday, the 10th of February 2024, around 6:30am after seeking the Lord, I was caught up in the spirit.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    I saw a dark cloud descend from the second Heaven to the third, spreading as wind and covering everything in darkness. This cloud was actually a fierce beast, unseen in full, with a womb giving birth to countless serpents that entered the earth and infiltrated the temple.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    These serpents afflicted many—biting, paralyzing, or even swallowing brethren—while others crushed the serpents with victory. I noticed that those overcome often waited for help instead of fighting back.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The Spirit instructed that Pastors were to go out and battle the beast in the air, while Christians should fight serpents on the ground. The beast changed form repeatedly, and swords were given to the Pastors in a violent aerial battle.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Later, I sought the Lord for interpretation. The Spirit revealed:
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border text-add italic text-xl">
                    “The Day of the visitation of wickedness has come, and unless the saints give themselves to spiritual warfare, they shall not prevail.”
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    Shepherds must teach the saints the full Armor of God so they can be fortified against evil. Every believer must rise in personal prayer and the Word.
                  </p>

                  <h2 className="text-xl text-text font-bold mb-3 pb-1">
                    Key Scriptures
                  </h2>
                  <ul className="list-disc list-inside text-add mb-6 text-lg space-y-2 font-bold">
                    <li>Ephesians 6:10-18</li>
                    <li>Ephesians 2:1-2</li>
                    <li>Luke 10:19</li>
                    <li>Isaiah 60:1-3</li>
                  </ul>

                  <p className="mb-6 leading-relaxed text-lg">The Priest of God</p>
                </VisionSection>

                {/* Vision 3 */}
                <VisionSection
                  id="lion-judah-vision"
                  title="The Vision About the Lion of Judah"
                  titleColor="from-red-500 to-red-400"
                  italicText="While in prayers, the Heavens were opened upon me and my spirit was caught up in the visions of God..."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider2.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg">
                    While in prayers, the Heavens were opened upon me and my spirit was caught up in the visions of God. In the vision, I saw a great Lion in a glowing red robe. The Lion was majestic and powerful.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The Lion spoke and said, "I am the Lion of Judah, the Root of David, mighty to save. My roar shakes the earth and the heavens." I saw the Lion fighting against great evil forces, and His roar caused them to flee.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Then the Lion raised His right paw, and lightning came forth, destroying the works of darkness that sought to enslave the people.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The Lord Jesus is calling His people to rise in faith and power to confront the enemy with His authority.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Great Grace
                    <br />
                    The Priest of God
                  </p>
                </VisionSection>

                {/* Vision 4 */}
                <VisionSection
                  id="battle-saints-vision"
                  title="The VISION OF THE BATTLE OF THE SAINTS AGAINST THE DRAGON"
                  titleColor="from-yellow-600 to-purple-500"
                  italicText="In the vision, I was transported out of this earth realm by an Angel and taken to another world..."
                >
                  <p className="mb-6 leading-relaxed text-lg">
                    In the vision, I was transported out of this earth realm by an Angel and taken to another world where I saw the great battle between the Saints and the Dragon.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The Dragon was huge, covered in scales of darkness, with seven heads and ten horns. The Saints wore the full armor of God and wielded flaming swords.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The battle was fierce and lasted for days in the vision. The Saints prayed fervently, and the Dragon’s power was diminished with every prayer.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Finally, the Dragon was cast down, and the Saints declared victory through the Blood of the Lamb and the Word of their testimony.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Great Grace
                    <br />
                    The Priest of God
                  </p>
                </VisionSection>

                {/* Vision 5 */}
                <VisionSection
                  id="pornography-vision"
                  title="THE VISION ABOUT PORNOGRAPHY (The Prophetic Cry Against the spirit of Jezebel)"
                  titleColor="from-pink-500 to-pink-400"
                  italicText='While in the place of prayer the Lord spoke to me thus ; "My Prophet arise and cry out against the Spirit of Jezebel..."'
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider3.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg">
                    While in the place of prayer the Lord spoke to me thus; "My Prophet arise and cry out against the Spirit of Jezebel that is working to destroy my church by seducing my people into sexual immorality and darkness."
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The Lord showed me how pornography and sexual sin have become a stronghold in many lives, and this spirit is the root of many other evils in the church and society.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    I saw the Lord commissioning intercessors and deliverance ministers to rise up with the sword of the Spirit to cut off this stronghold and set the captives free.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Let the church rise and take back the ground lost to this enemy through repentance, prayer, and holiness.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Great Grace
                    <br />
                    The Priest of God
                  </p>
                </VisionSection>

                {/* Vision 6 */}
                <VisionSection
                  id="gathering-army-vision"
                  title="The Vision of the Gathering of the Heavenly Army and the Command of the King of Kings!"
                  titleColor="from-blue-400 to-blue-300"
                  italicText="I was caught up in the visions of God, and I saw a great gathering of beings, both earthly and heavenly..."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider4.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg">
                    I was caught up in the visions of God, and I saw a great gathering of beings, both earthly and heavenly. They were preparing for a mighty campaign against the forces of darkness.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The King of Kings stood before them and commanded His army to take back what the enemy has stolen. The heavenly hosts shouted in unison, and the earth trembled.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    This vision is a call to all saints to join in the spiritual battle with faith, prayer, and obedience.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Great Grace
                    <br />
                    The Priest of God
                  </p>
                </VisionSection>

                {/* Vision 7 */}
                <VisionSection
                  id="invasion-children-vision"
                  title="The Vision of the Invasion of the Children from the Great Waters"
                  titleColor="from-indigo-400 to-indigo-300"
                  italicText="This Morning in-between 3 am to 5 am I saw a vision from the Lord, that unveiled to me the plans of the kingdom of Darkness against the Earth..."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider5.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg">
                    This Morning in-between 3 am to 5 am I saw a vision from the Lord, that unveiled to me the plans of the kingdom of Darkness against the Earth.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    I saw Children rising from the Great Waters; these children were not ordinary. They carried spirits of confusion, deception, and chaos.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    These children were sent to infiltrate the hearts of the people and to turn them away from the truth of the Gospel.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    But the Lord is preparing a remnant to stand firm in faith, armed with the Word and Spirit.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Great Grace
                    <br />
                    The Priest of God
                  </p>
                </VisionSection>

                {/* Vision 8 */}
                <VisionSection
                  id="great-banquet-vision"
                  title="THE VISION OF THE GREAT BANQUET"
                  titleColor="from-yellow-500 to-yellow-400"
                  italicText='Today I was caught up in the spirit and, the Lord said to me; "Now the Hour has come to gather all men to Me..."'
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider6.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg">
                    Today I was caught up in the spirit and, the Lord said to me; "Now the Hour has come to gather all men to Me, the Great King, the Lord of Hosts."
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    I saw a great banquet prepared with fine food and wine. The King invited everyone to come and partake.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Some refused, making excuses, but others humbled themselves and came.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The Lord calls today for repentance and reconciliation. The doors of grace remain open, but soon the judgment will come.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Great Grace
                    <br />
                    The Priest of God
                  </p>
                </VisionSection>

                {/* Vision: The Demonic Agenda to Corrupt the Worship Ministry */}
                <VisionSection
                  id="demonic-agenda-vision"
                  title="The Vision about the Demonic Agenda to Corrupt the Worship Ministry"
                  titleColor="from-purple-300 to-purple-700"
                  italicText="While I was waiting on the Lord, to know His mind for this time and season, His Word came to me thus;"
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider7.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg italic">
                    "This is the season where the Spirit of grace and supplication will be poured upon the saints to summon men and women into the secret place, to minister unto the Lord and bear the burdens of God through their priesthood for the advancement of His Purpose on earth."
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    When the Lord spoke to me, He opened my eyes and I saw indescribable beings in the clouds and an angel of the Lord revealed to me that those beings were Cherubims and Seraphims. The Angel said to me that the Lord is releasing them as ministering spirits to the earth realm to usher the saints into a realm of fellowship with the Holy Father.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The Angel said that the Cherubims are assigned to communicate the Glory of God into the atmosphere while the Seraphim are assigned to communicate the Holiness of God into the atmosphere, and this atmosphere will influence the saints to walk in the consciousness of the Holy Father.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    While he was talking to me, I was carried to an assembly of Christians in worship. While they were worshipping God, their words were transformed into a thick white smoke going up to heaven and afterwards it returned on them as rain, each drop containing light, which when it came back upon the people, it revived, renewed, and refreshed them.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Then as we watched, I was carried again to another assembly of people worshipping God, but I saw something strange. Theirs was a thick dark smoke; it did not ascend to God, rather it surrounded them, and out of the smoke emanated a very bad odor like that of dead flies. The odor came upon the people and remained on them.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    When I saw this, I asked the Angel what was wrong; and the Angel said, "Come and see." Immediately I was in another vision of God. In this vision, I saw demons and evil spirits that had a very bad odor, speaking in a strange tongue, and each time they spoke, the tongues multiplied themselves. After a while, wind carried them into the atmosphere, and their targets were Pastors and Gospel Ministers, especially girls.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    They specifically targeted girls gifted in singing and choir members. When this was done, these girls began speaking in that same tongue, but unfortunately most of them were not aware. Now, whenever the girls began leading worship and spoke in those tongues, the thick dark cloud would cover the assembly, and out of the thick dark clouds would proceed that bad odor.
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add">
                    The Evil One, in his subtle wisdom and crafty ways, has released an Evil Spirit to corrupt the Spiritual Atmosphere of the Saints by influencing them to speak in tongues inspired by the flesh and familiar spirits. Instead of praying to God, they are enchanting demons, cursing themselves, and committing their bodies to the hands of Evil Spirits.
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    Then the Angel showed me further: I saw a woman very beautiful, with very long hair—longer than hers—and with very bright eyes. The Angel said that is the Spirit of Delilah, and she has been granted an assignment by the Evil One against servants of God, to seduce them and cause them to transgress the commandments of the Most High God by sexual sins.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The spirit was assigned to female Gospel musicians, and I saw in the visions when they start singing and speaking in tongues, they were casting spells of lust on the people present, and they would seduce and entice the servants of God into sexual immorality with them.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    I saw again that this demon had beings around her, worshipping her, yet they were Gospel singers. These ones, unlike the others, were conscious that they were possessed with those evil spirits and were on assignment to pollute the sanctuary of God with sexual immorality. I saw these female so-called Gospel artists leading other younger girls into having sexual intercourse with them, introducing them into homosexuality—all this in church.
                  </p>

                  <p className="mb-6 leading-relaxed italic font-semibold">
                    At this point, I was very disturbed and the vision ended. I kept praying, asking the Lord what should be done.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    And the Holy Spirit said that all music ministers in church must consecrate themselves—spirit, soul, and body—to walk in righteousness and Holiness, because the responsibility to provoke and sustain the manifestation of God in this time and season is upon them. That's why the devil is coming after them, but the devil will not be able to operate through those who walk in the Light of Life.
                  </p>

                  <h2 className="text-xl text-text font-bold mb-4 pb-1">
                    Scriptures for Strength and Guidance
                  </h2>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add font-semibold">
                    John 4:23 KJV <br />
                    "But the hour cometh, and now is, when the true worshippers shall worship the Father in spirit and in truth: for the Father seeketh such to worship him."
                  </blockquote>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add font-semibold">
                    Romans 12:1 KJV <br />
                    "I beseech you therefore, brethren, by the mercies of God, that ye present your bodies a living sacrifice, holy, acceptable unto God, which is your reasonable service."
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    I counsel the Female Gospel Musicians to AVOID serving God according to the standards of the World. They must serve and follow God by the standard of the Word because they are called to give pleasure to the Lord God through their worship and praise. But their worship is Only acceptable to the Righteous One when they offer their body as a living sacrifice to God.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    Dear daughters of Zion, arise and lead the church to the place of intimacy with God through the Spirit of God. Refuse to be vessels in the hands of Satan to cause the downfall of His servants, for you are ordained to be vessels of honor in the hands of God to draw men and women closer to God.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-bold">
                    Great grace; <br />
                    The Priest of God.
                  </p>
                </VisionSection>

                {/* Vision: The Vision of the Mountain of Transfiguration */}
                <VisionSection
                  id="mountain-of-transfiguration-vision"
                  title="The Vision of the Mountain of Transfiguration (The Encounter with The Lord Jesus, Elijah and Moses)"
                  titleColor="from-blue-500 to-blue-400"
                  italicText="While waiting on the Lord and seeking His face for the New Year, I was privileged through the Grace of God to be carried into the visions of God where I experienced a glorious encounter with the spirits of Just Men Made Perfect and the Lord Jesus."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider8.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg">
                    While I was praying, I was caught up in the Spirit and I saw a mountain and there was a bright light shining from the mountain but the Light was full of a heavenly sound. While I was looking at the Light, a cloud came upon me, overshadowed me and carried me to the top of the mountain where the Light was.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    When I got to the mountain, I saw two men, dressed in white long robes with a golden embroidery and long white hair, and there was a pillar of Light between them. I could perceive a deep Love proceeding out of this pillar of Light, and the rays from this pillar of light flowed into Elijah and Moses and made them also to glow and it surrounded them in a ball of Light in which they were shining bright.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    While I was looking at them, in my heart, by the intelligence of the Spirit, I knew it was Moses and Elijah. In their hands were many scrolls; they opened their hands and the scrolls started flying and in them were written the decrees of the watchers concerning the affairs of people, nations, languages, and kings.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    And all of these were written in heavenly language but when I looked steadfastly at one, the writing was translated into English and this is what I read:
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add">
                    "This is the Acceptable Year of the Lord and the Terror of his name, from this Year henceforth, through the Manifestation of the Mighty Power of the Spirit, Men shall Fear the name of the Lord to the ends of the Earth."
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    As I read this, I became aware that the pillar of Light in the middle of Elijah and Moses was the Lord Jesus and with this awareness came great awe and reverence for the Lord Jesus.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Many other things were communicated to me from the other scrolls but I've not yet received the permission nor the utterance to declare them to the hearing of the sons of men.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    For now, the focus of the Holy Spirit is that all men should Perfect themselves in the Fear of God and Walk before the Lord Jesus Christ blamelessly, for while I was pondering on this vision, I saw a glimpse of another vision thus:
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    I saw a Mighty Angel who was shining like the sun and he was flying with a scroll and a trumpet, and he uttered thunderings thereof and these were the words:
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add font-semibold">
                    "Fear God, and Give Him Glory, for the hour of his Judgment has come, and all that do not Fear Him Shall be consumed by the Fire of His wrath but they that Fear Him shall be satisfied with the good things of His Hand, for He shall Cause them to approach him and will show them his Graciousness!"
                  </blockquote>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add font-semibold">
                    "Beware of the hidden sins of the heart, beware of the sins of the flesh, beware of the yeast of the world, beware of the seduction of Babylon, beware of the deceptions of the Old Serpent!"
                  </blockquote>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add font-semibold">
                    "O People of the True God, Hear the True Gospel and Turn away from Sin, Hear The True Gospel and be consecrated unto the Lord Your God, Hear the True Gospel and Separate yourselves from the workers of Iniquity for behold the Lord is Gathering unto Himself a remnant of Men and Women who will not bow to Babylon neither shall their lips kiss her."
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    And He continued again:
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add font-semibold">
                    "Fear God and Repent of every sin that He May wash you in the blood of the Lamb and cause you to walk blamelessly before him and receive Your Great reward from His hand."
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg font-bold">
                    Great grace! <br />
                    The Priest of God!
                  </p>
                </VisionSection>

                {/* Vision: The Vision of the Lord Jesus and His Message to the World */}
                <VisionSection
                  id="lord-jesus-message-vision"
                  title="THE VISION OF THE LORD JESUS AND HIS MESSAGE TO THE WORLD!"
                  titleColor="from-red-500 to-red-400"
                  italicText="By the privilege of Grace, I was carried by the Spirit of God into the visions of God and this is what I saw:"
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider9.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg">
                    I saw the heavens opened and I saw thousands of Angels and Cherubims coming out of the heavens. Some of them were making heavenly melodies with trumpets and heavenly instruments of praise. After this, I saw some other mighty Angels coming forth and they were spreading a golden-red carpet-like material from the heavens to the earth realm where we were. When they finished doing this, the heavenly beings made beautiful heavenly melodies with their instruments of praise again.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Then suddenly I heard the voice of the trumpet that thundered from the Heavens, and another kind of Angels came forth and shouted "behold, the King is coming." When I heard this, I lifted my head and looked and behold, there He was, coming out of the clouds with glory and honor that cannot be described by earthly words. There is no language on earth by which we can explain the splendor of His glory!
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The Lord Jesus was clothed in a white long robe, with a red sash on which was inscribed some words in gold. These words were in a heavenly language and the interpretation was not given to me. His face was shining; He was neither white nor black, HE WAS LIGHT. Just shining! No earthly colour can be used to describe his complexion. The only word is LIGHT! He came forth with a beautiful smile on His face; the radiance of his smile filled the atmosphere with bliss, peace and joy.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    I was caught in amazement then He came to where we were and began calling everyone by name, and some people were saying to themselves and to one another, "He knows my name" and they were so full of joy that some burst into tears and were exclaiming, “He knows my name, the Lord knows my name."
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Then He came to me and called me "Kevin." I was so caught in awe that I could not even answer but there is something I remarked; THE LORD JESUS IS VERY SIMPLE and EXTREMELY HUMBLE.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    He moved in the midst of the people, embracing them and talking to them, wiping tears off their eyes and laughing with some others. I said to myself, "is this how the Lord Jesus is simple?”
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    All those Angels stood afar while He moved in the midst of His people. Then I said again in my heart "ah the Lord Jesus is simple, until there is no protocol to interact with him!” Immediately, the Holy Spirit echoed the words of the Lord Jesus in my heart as recorded in Matthew 11:28-29:
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add font-semibold">
                    "Come unto me, all ye that labour and are heavy laden and I will give you rest. Take my yoke upon you, and learn of me; for I am gentle and humble: and ye shall find rest unto your souls."
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    And when the Holy Spirit spoke these words in my heart, I confessed and said "Truly, the Lord Jesus is gentle and humble" and when I said that, The Holy Spirit said to me "Learn from Him."
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    At this point, I turned and saw that there was a group of people who stood afar off and while I was wondering why, the Lord Jesus looked at me and pointed them to me and said “Go and tell them to come to me, tell them not to be afraid or ashamed, for I love them with an everlasting love."
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    So, I went and told the people and they started following me to the Lord Jesus. Each time any of them came to the Lord Jesus, He embraced them and the Angels made beautiful melodies with their instruments of praise. Oh Hallelujah! What a glorious sight it was.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    At this point, I was so amazed that I ran and began shouting to people "come, Jesus is calling for you, don’t be ashamed, don't be afraid, He loves you with an everlasting Love.” Then I woke up!
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    Oh, what a wonderful God we serve. Glory and honor be to the Lord Jesus our King!
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    To those who have not yet surrendered to the authority of the Lord Jesus, or have surrendered but are backslidden; I say this to you under the influence of the Spirit of prophecy; “the Lord Jesus is calling for you. Come to Him NOW. Don't be afraid or ashamed. He loves you with an everlasting love!”
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    It does not matter what you have done or are doing. What matters is what the Lord Jesus has done for you on the cross; His blood was shed for the forgiveness of your sins and He was raised from the dead for your justification and salvation! Welcome home, Dear brother and sister! Again I say to you welcome to the kingdom of the Lord Jesus, which is Righteousness and Peace and Joy.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    To the Church the Holy Spirit says this “the Lord your God is walking in your midst, and He will show Himself mighty on your behalf through awesome deeds of righteousness for the glory of His Name."
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-bold">
                    Great Grace, <br />
                    The Priest of God.
                  </p>
                </VisionSection>

                <VisionSection
                  id="lord-jesus-grieved-vision"
                  title="The Vision of the Lord Jesus Grieved"
                  titleColor="from-red-600 to-red-500"
                  italicText="On the morning of Tuesday, December 26th, I had a deeply troubling vision of the Lord Jesus."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider10.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg italic">
                    On the morning of Tuesday, December 26th, I had a deeply troubling vision of the Lord Jesus. I had devoted myself to prayer, fasting, and seeking the presence of the Lord throughout the day, immersing myself in His word and spending the night in His presence as I customarily do every last month of the year.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    While waiting upon the Lord, I felt the hand of God upon me, transporting me into the visions of God. In the spirit, I looked up and witnessed the first heavens being rolled away like a carpet, revealing an open door beyond them. I saw a brilliant light emanating from the heaven of heavens, and I discerned through the prompting of the Spirit that it was the atmosphere of His presence, indicating the imminent appearance of the Lord Jesus. With a lifted voice, I began to worship the Lord Jesus, exclaiming, "Welcome, Lord Jesus!"
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Suddenly, a multitude of celestial beings emerged from the door, followed by the Lord Jesus Himself. However, His arrival was accompanied by an unusual aura of mourning and brokenness. I had never experienced such a feeling before. The Lord stood suspended in mid-air, and I greeted Him, saying, "Welcome, Lord Jesus." Yet, He remained silent.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Beside Him stood a mighty angel who opened his mouth to speak. His voice sounded like thunder, filling me with the fear of God and a deep reverence for the Lord Jesus. He spoke in an unfamiliar language, and all I could hear were rumbling sounds like thunder. Then, a hand appeared and began writing His message in the heavens. I caught a glimpse of the words, <q>You are degrading the Lord Jesus when you...</q> but I was unable to finish reading as the statements rapidly changed.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg italic font-bold">
                    Overwhelmed with sorrow, I began weeping and repenting before the Lord, seeking His mercy. Suddenly, the Lord and the angels returned through the heavenly door, and I found myself back in the physical realm. The sight of the Lord Jesus' face had greatly disturbed my spirit. It wasn't that He appeared angry, but rather, He seemed grieved.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    I became concerned because I couldn't recall the exact content of the last statement regarding how I or we had been degrading the Lord Jesus. While I was praying, the Holy Spirit communicated to me, <q>It is so, so that each one may examine their own life, identify areas where they have degraded the Lord Jesus, repent and do the things that are pleasing to the Father.</q>
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    And while pondering I was in the Spirit and the Angel of the Lord came to me and I asked him what does the Mighty Angel Mean by we are degrading the Lord Jesus, and He replied said to Me; <q>When you think thoughts, say words or do works that are not consistent with the Will of the Father, You hinder the Manifestation of the fullness of the Glory of The Lord Jesus and thus degrade Him in Your Life.</q> And he continued saying; <q>In each of your thoughts, words and works you either magnify the Lord or degrade Him in your life and in the sight of Men.</q>
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    So when I heard this I asked him again; what is the secret of More of God, and He replied me: <q>More of You.</q> Then he said again <q>You have All of God but God is Spirit and the Measure of the Spirit You will experience depends on the measure of the Flesh you will sacrifice.</q>
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-bold">
                    Beloved, I testify before God the Father of our Lord Jesus that I speak the truth. The Lord Jesus is grieved by the works of unrighteousness and iniquity committed by His people. Furthermore, He is grieved when we engage in actions that contradict His will as revealed in Scripture or through His Spirit!
                  </p>

                  <h2 className="text-xl text-text font-bold mb-4 pb-1">
                    Scripture Reminder
                  </h2>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add font-semibold">
                    2 Corinthians 13:5 (KJV)<br />
                    <q>Examine yourselves, whether ye be in the faith; prove your own selves. Know ye not your own selves, how that Jesus Christ is in you, except ye be reprobates?</q>
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    While asking the Lord what to do about this vision, the Holy Spirit made me understand two things:
                  </p>

                  <div>
                    <ul className="list-decimal list-inside mb-6 text-lg space-y-3">
                      <li>
                        We must repent of all works of unrighteousness. I urge everyone to approach the Father with a broken and contrite heart, seeking His face. Allow the Holy Spirit to reveal the areas where you may be degrading Jesus personally. We must repent of all acts of immorality, lying, unforgiveness, jealousy, rebellion, and all the works of the flesh that are not pleasing to the Lord Jesus.
                      </li>
                      <li>
                        The Holy Spirit instructed me to tell the People of God to commit themselves to giving thanks to the Lord in all things, because there is no greater act that degrades the Lord Jesus than complaints against Him because of trials and temptations. Remember the Words of our Lord Jesus recorded in Matthew 11:6; <q>And blessed is he, whosoever shall not be offended in me.</q>
                      </li>
                    </ul>
                  </div>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add font-semibold">
                    Colossians 3:17 KJV<br />
                    <q>And whatsoever ye do in word or deed, do all in the name of the Lord Jesus, giving thanks to God and the Father by him.</q>
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    I earnestly pray that the Holy Spirit will enable you to behold the face of Jesus in your heart and experience the grief that fills the Lord's heart due to the unrighteousness and complaining of His own people. May the Holy Spirit convict you of sin, righteousness, and judgment as you read this, so that you may genuinely repent and commit yourself to walking in righteousness and offering continual Thanksgiving unto the Lord Jesus.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-bold">
                    Great Grace <br />
                    The Priest of God
                  </p>
                </VisionSection>

                <VisionSection
                  id="vision-of-the-palm-branches"
                  title="THE VISION OF THE PALM BRANCHES"
                  titleColor="from-green-500 to-green-400"
                  italicText="I was caught up in the visions of God where we were gathered in the assembly of the saints..."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider11.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg italic">
                    I was caught up in the visions of God where we were gathered in the assembly of the saints and the Holy Spirit manifested Himself and prompted us to worship the Lord Jesus, and as the whole congregation were worshipping, the awe of the presence of God brought me to my knees in reverence to the LORD JESUS, and the spirit of Holiness granted me utterance and I began to glorify and magnify the Lord Jesus with the confessions of my mouth, and I was filled with the awareness of the Majesty and Dominion of the Lord Jesus and I began to sing this song:
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-lg text-add font-semibold">
                    "When we all get to heaven /<br />
                    what a Day of rejoicing that will be /<br />
                    when we all see Jesus /<br />
                    we will sing and shout Victory /"
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    And while I was singing this, I saw a thick white Cloud come upon me and suddenly my spirit was caught up into the realms of God and I saw myself instantly kneeling before the Lord Jesus, the Only Potentate, the King of kings and Lord of lords - His throne was made of Gold, and transparent glass and He sat exalted upon the throne, I mean highly exalted and His throne was surrounded with a cloud that had a rainbow, and therein were flashes of lightning and out of which proceeded voices that sounded like thunder saying, <q>Holy, Holy, Holy is the Lord God Almighty, Glory, Glory, Glory be unto He who sits on the throne, for His dominion endures forever more.</q>
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Then I was filled with Holy Fear, and my head was bowed down, and as I lifted my head to behold He that dwells in inapproachable light, I could not see his face, for it was full of a burning and shining light, and then He spoke to me, His voice sounded like many waters but was so gentle and refreshing to the heart, the Lord Jesus said these words:
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-lg text-add font-semibold">
                    "Verily I say unto you, all of those who have confessed my name and have not been ashamed of my Gospel, will surely be carried to heaven when their days are fulfilled and they shall be where I am for I have prepared a place for them in the bosom of Abba Father, but the issue is, what shall they bring when it is time to come and meet me?<br />
                    Shall you come before your Master empty handed?"
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    Then I turned and looked and I saw many beings in white garments and some had palm branches in their hands and some their hands were empty, some had many palm branches and some had just few.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    And all these came before the throne of the Great King and cast their palm branches down before the Lord one after another, and the Lord received it from their hands and gave them crowns, each crown was different in size and beauty, some crowns had more stars on them than others and some had more precious stones than others but it appeared to be that it is your palm branches that will determine the kind of crown you will receive.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg italic">
                    And while I was wondering what this could be in my heart, it is like a being heard my thoughts, and He walked up to me and said to me, this is the meaning of this mystery:
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-lg text-add font-semibold">
                    "If you do good works and win souls into the Kingdom of God, when you come to meet the Lord, all your good works for the advancement of his glorious kingdom will be in your hands in the Heavenly realms as palm branches, and the crowns given to them is their reward which they will receive from the Lord their God for their sacrifices for his kingdom."
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    And the Holy Spirit brought this scripture to my remembrance which I have been reading but never understood:
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-lg text-add font-semibold">
                    Revelation 7:9 KJV<br />
                    After this I beheld, and, lo, a great multitude, which no man could number, of all nations, and kindreds, and people, and tongues, stood before the throne, and before the Lamb, clothed with white robes, and palms in their hands;
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    And I began saying to myself I must do good works and win souls for the advancement of the Kingdom of Jesus Christ, then suddenly my spirit was back in my body in church and I was in utter amazement because on earth it was not up to 30 minutes but while in the heavenly realm, it was like 7 hours because I saw and heard so many things which I've not been permitted nor given the utterance to tell the sons of men.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg italic font-semibold">
                    But the Lord Jesus has Graciously sent me to bring this message to the church today;
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 borde-border italic text-lg text-add font-semibold">
                    "Shall you meet your maker empty handed? <br />
                    What are your good works? <br />
                    Where are the souls you have converted from the World to the Lord?"
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    If you are born again, then going to heaven is a sure truth because salvation is by faith in Christ and not by works but your reward in heaven will be by your works which are an expression of your faith in Christ.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    What will you bring to the Lord Jesus, who gave Himself for you and washed you from your sins and through whose blood you are reconciled to the Righteous Father?
                  </p>

                  <p className="mb-6 leading-relaxed text-lg italic font-semibold">
                    As a saint, do not just be excited about being carried to heaven when your days are fulfilled, even much more be excited at the palm branches you will present to your master Jesus Christ.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    Oh Dear Saint,<br />
                    Shall you meet your Master Empty Handed?
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Have you not read this scripture:
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-lg text-add font-semibold">
                    Deuteronomy 16:16 KJV<br />
                    Three times in a year shall all appear before the Lord thy God in the place which he shall choose; in the feast of unleavened bread, and in the feast of weeks, and in the feast of tabernacles: "and they shall not appear before the Lord empty".
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    May the God of All Grace grant us grace and wisdom to be and do what is ordained for us that will advance the Glorious kingdom of Christ in the Name of Jesus<br />
                    Great grace<br />
                    The Priest of God
                  </p>
                </VisionSection>

                {/* Vision: The Evil Birds Covering the Light of Heaven */}
                <VisionSection
                  id="evil-birds-cover-light-heaven"
                  title="THE VISION OF THE EVIL BIRDS THAT COVERED THE LIGHT OF HEAVEN WITH THEIR WINGS"
                  titleColor="from-red-600 to-red-400"
                  italicText="On Saturday 27th of April around 2am earthly time, after praying and calling upon the Lord to cause His face to shine upon His people..."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider12.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg">
                    On Saturday 27th of April around 2am earthly time, after praying and calling upon the Lord to cause His face to shine upon His people, that they may walk in favor, I was caught up in the realm of the Spirit, and I saw the visions of God.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    In these visions of God, I was standing on a mountain with thousands of saints, and it was the dawn of the day. There was a very bright light shining from the heavens upon all of us, and the light had healing in its wings. When it shone upon us, it brought peace, joy, and prosperity. While we lifted our hands and were worshiping the Lord, I saw a legion of demon spirits come from a valley. They came at swift flight, looking like birds because they were foul and ugly creatures with wings.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    As they came above the saints in the mid-air and spread their wings, they joined to one another. In a moment's time, everywhere was dark. We were no longer seeing the light that was shining from the heavenly realms, except for some few people. A little light would shine from in-between some of these demon spirits whose wings were not properly joined. So, from the little crack, little light would come down.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    I saw how most, if not all, of the saints would rush to that area where the little light had broken through, but that light was not enough for them because they were so many.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Then the vision ceased, and I came back to this earthly realm. While I was wondering what this was, I was caught up again swiftly, and this time, I saw that those on whom the light had broken through were under attack. I saw how some of these creatures with wings would come fly down from the heavens and just be above their heads, covering them with their wings, and they too could no longer see any light.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    There is something I realized when those demon spirits came. I realized that for me to see them, the eyes of my spirit opened up, and though everywhere was dark, I could see them clearly. As they covered the people, there was great lamenting and complaining from the saints, for their lives became bitter.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    At this point, the vision ceased, and I sat at my place of prayer in great amazement.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    As I began to pray to seek the face of the Lord concerning the vision, I received this interpretation from the Spirit:
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The day was the day of the Lord's favor, and we are ushered into the day of the Lord’s favor when we become born from above. The Spirit brought this scripture to my remembrance:
                  </p>

                  <p className="mb-6 leading-relaxed text-lg italic">
                    "For he saith, I have heard thee in a time of favor, and in the day of salvation have I helped thee: behold, now is the time of the favor; behold, now is the day of salvation." [2 Corinthians 6:2]
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The light I saw was the favor of the Lord. It came from the heaven of heavens and shone upon His people, bringing them into the experience of the goodness of the Lord. The Spirit brought this scripture to my remembrance:
                  </p>

                  <p className="mb-6 leading-relaxed text-lg italic">
                    "The Lord make his face shine upon thee, and be gracious unto thee." [Numbers 6:25]
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The evil birds are demons assigned by Satan to hinder the light from shining upon the people of the Lord. I heard these words clearly:
                  </p>

                  <p className="mb-6 leading-relaxed text-lg italic">
                    "The evil one has set up an evil veil to hinder the light of the face of the Lord from shining upon people so that they may not see the favor of the Lord, and His favor will not see them. You must engage them into warfare with the full armor of God and destroy that veil that you may experience the day of the Lord’s favor in which you now are. That Evil veil is the instrument by which the Evil one is Misrepresenting the Father to the Saints"
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    And these scriptures were brought to my remembrance:
                  </p>

                  <p className="mb-6 leading-relaxed text-lg italic">
                    "In whom the god of this world hath blinded the minds of them which believe not, lest the light of the glorious gospel of Christ, who is the image of God, should shine unto them." [2 Corinthians 4:4]
                  </p>

                  <p className="mb-6 leading-relaxed text-lg italic">
                    "And he will destroy in this mountain the face of the covering cast over all people, and the veil that is spread over all nations." [Isaiah 25:7]
                  </p>

                  <p className="mb-6 leading-relaxed text-lg italic">
                    "And the Angel cried mightily with a strong voice, saying, Babylon the great is fallen, is fallen, and is become the habitation of devils, and the dwelling of every foul spirit, and a cage of every unclean and hateful bird." [Revelation 18:2]
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    I counsel every saint to contend against these evil spirits. It is their operation that makes it look as though the Lord is not blessing; their operations make it look as though God is not good. By the power of the Spirit, violently contend against them and tear the evil that the light of the face of the Lord may shine upon you and cause you to find favor.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Remember this scripture:
                  </p>

                  <p className="mb-6 leading-relaxed text-lg italic">
                    "Put on the whole armor of God, that ye may be able to stand against the wiles of the devil. For we wrestle not against flesh and blood, but against principalities, against powers, against the rulers of the darkness of this world, against spiritual wickedness in high places." [Ephesians 6:11-12]
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    May the fire of God tear the evil veil the devil has cast upon the face of the earth to hinder men from seeing the light of the face of the Lord.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    Great Grace, <br />
                    The Priest of God.
                  </p>
                </VisionSection>

                <VisionSection id="encounter-moses-samuel-book-generations" title="My Encounter with Moses and Samuel and The Revelation of the Mystery of the Book of the Generations of the Earth"
                  titleColor="from-blue-400 to-blue-700"
                  italicText=" On the night of the 18th of March, I had a strange vision in which I saw mysteries and heard unspeakable words, which are not lawful for Man to utter unless he is given utterance by the Spirit of the Lord.">
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider13.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <p>
                    The Spirit of the Lord came upon me and carried me into the visions of God. I saw two Men who were Elders, and by the intelligence of the Spirit, I knew that their names were Moses and Samuel. They began speaking to me about the Ministry of The Priest and the Ministry of the Prophet. They revealed to me that this is the order of Prophets that the Lord is raising now: Prophets who are also Priests. While they were speaking, the Spirit of doubt came upon me, and I said in my heart, "Is this just a dream and the work of my mind? Were Moses and Samuel Priests, or were they not Prophets?" Immediately as I spoke in doubt, the vision ceased, and I awoke from my sleep. I prayed, saying, "Lord Jesus, forgive me for doubting, but if this vision is from You, let it come back again." As soon as I said that, deep sleep came upon me, and the visions came again. This time, as Moses and Samuel stood before me, an angel came forth and said to settle my doubts, I shall see what is written on the scroll. I saw it written:
                  </p>
                  <p><em>"Psalm 99:6; Moses and Aaron among his priests, and Samuel among them that call upon his name; they called upon the Lord, and he answered them."</em></p>
                  <p>
                    When I saw this scripture, my conviction was strengthened, and the vision continued. This time, Moses and Samuel took me to a Hall, a very large Hall. It was like it was in the Middle of the earth, and in there I saw millions of Beings writing scrolls. I saw a book; it was written: <em>"The Book of the generations of the earth."</em> In this book, I Saw that all what God intends each day was written down even before the day came. All activities, occurrences of every second, minute, and hour of the day were written down in detail! This book had been written from beginning to ending!
                  </p>
                  <p>
                    At this point, the Holy Spirit brought to my remembrance this scripture:
                  </p>
                  <p><em>"Your eyes saw my unformed body; all my days were written in Your book and ordained for me before one of them came to be." (Psalm 139:16)</em></p>
                  <p>
                    Then I saw something strange. I saw another book again, but this time around, things were written in the Book at the end of the day. Moses said to me, "In the First book is written the things that are prepared and ordained by God to happen; in the second, the things that happened. On the day set in the week for the Gathering of the Holy Ones, the books are put in the scale."
                  </p>
                  <p>
                    When he said this, I saw what he meant. I saw that when they had recorded the things that happened in a day, they would take it and put it on a scale. On the right side was the book of the generations of the earth recorded before the day, and on the left side was the book recorded after the day. Samuel said to me, "If there is a balance on the scale, then the day is recorded as a Perfect Day. That is a day in which Man did the things that were ordained by God for him to do. The day in which all the things that God ordained to happen, happened actually. A Perfect day is the day in which a Man walked in the Light of that which was written of him by the finger of the Lord."
                  </p>
                  <p>
                    Sadly, I saw that for the majority of the days, there was no balance. The book that was recorded after was always found wanting; few days were perfect days. Most often, the sons of Men did not walk in the Light of what God ordained for them in the day.
                  </p>
                  <p>
                    Now I saw something quite spectacular. When the books were opened, the words written turned into pictures. I saw that most of the sons of Men do not even fulfill half of what God ordained for a day!
                  </p>
                  <p>
                    Then when this happened, I was worried in my Spirit and said to myself, "How can one have a Perfect Day?" As I said this, instantly the Spirit brought this scripture into my heart:
                  </p>
                  <p><em>"Psalm 90:12; So teach us to number our days, that we may apply our hearts unto wisdom."</em></p>
                  <p>
                    At this, Moses said to me, "The Secret of having a Perfect Day is praying Every Morning at the Dawn of the Day. When you pray in the Morning, you submit yourself to the Will of God and thus come under the influence of the Holy Spirit, who will guide your feet into the way ordained for the day." He continued, saying, "When you pray in the Morning, you bring the day under the control of the Holy Spirit and the Holy Angels. That which was written in the books of the generations of the earth will be written in Your heart, and You shall be led in your course of the day, where you will obtain all that which the Good Father has prepared for You."
                  </p>
                  <p>
                    At this point, Samuel said to me, "The Secret of having a perfect day is declaring the Mercy of the Lord at the breaking of the Dawn and commanding your day by confessing the Holy Scriptures."
                  </p>
                  <p>
                    When he said this, the Spirit brought this scripture to my spirit:
                  </p>
                  <p><em>"Psalm 90:14 KJV; O satisfy us early with thy mercy; that we may rejoice and be glad all our days."</em></p>
                  <p>
                    Samuel continued, saying, "The Evil one and his angels have set their hearts to resist the Will of the Great God Jehovah, and thus they set up snares daily to subvert Men out of their course. This is the reason for so many evil occurrences befalling the sons of Men, even those who are of the household of Faith. The Great God Jehovah is a Good Father, and All he has written and ordained for the days of Men are for good and not for evil. He has prepared daily bread for all Men on earth, but only few actually take hold of their daily bread. Others have turned their daily bread into weekly bread, thus they are never having enough, not knowing that All what the Father has prepared is more than sufficient. Verily I say unto You, if You walk in the course of the day as ordained by the finger, then, as the scripture had said, you too shall say 'The Lord Is my Shepherd I shall Not Lack'!"
                  </p>
                  <p>
                    At this point, my eyes were opened, and I saw millions of spirits of the air that looked like Circus clowns. They were sent to distract men, cast the Spirit of heaviness upon them, and keep them busy with doing the things that do not align with the Will of the Father for them in that Day. Moses said to me, "These are devourers of Years," and I remembered the scripture:
                  </p>
                  <p><em>"Joel 2:25; And I will restore to you the years that the locust hath eaten, the cankerworm, and the caterpillar."</em></p>
                  <p>
                    Now I understood what it meant. When I was meditating about it, I heard the Voice of the Spirit saying,
                  </p>
                  <p><em>"See then that you walk circumspectly, not as fools, but as wise, redeeming the time, because the days are evil."</em></p>
                  <p>
                    At this point, I came out of the vision.
                  </p>
                  <p>
                    Now, this is my counsel: let the saints practice early morning devotion, especially as a family. Even if they are two or three people, it will be better, but even if you are alone, still do it. The saints should no longer despise early morning devotions; it should become a consistent daily habit as it is written:
                  </p>
                  <p><em>"LORD, in the morning you will hear my voice; in the morning I will pray to you, and I will watch for your answer." (Psalm 5:3)</em></p>
                  <p>
                    Scripture teaches us that this was the daily habit of our Lord Jesus:
                  </p>
                  <p><em>"In the morning, while it was still very dark, Jesus got up and went to a deserted place and prayed there." (Mark 1:35)</em></p>
                  <p>
                    It's time to take charge of the day. Do not allow the devil and his angels to ensnare you and divert you from your course. It's time to walk in the Light of what was ordained for every day, doing the things commanded by the Father and receiving the good things prepared by the Father!
                  </p>
                  <p>
                    Now this is the Mystery; You command Your Day by Proclaiming the Mercy of God over the day in the Morning, and your command the night by Proclaiming the Faithfulness of God in the evening over the Night, even as it is written;
                  </p>
                  <p><em>"It is good to give thanks to the LORD and to sing praise to your name, Most High; to proclaim your Mercy in the morning and your faithfulness at night" ( Psalm 92:1-2)</em></p>
                  <p>
                    Great Grace,<br />
                    The Priest of God.
                  </p>
                </VisionSection>

                <VisionSection id="my-visit-to-heaven-full-version" title="My Visit to Heaven ( Full Version )"
                  titleColor="from-yellow-400 to-yellow-700">
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider14.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p>
                    On this ordained night of visitation, I felt a sudden heaviness and I fell asleep as I closed my eyes. Immediately the eyes of my spirit were opened by the Lord and I saw two Mighty Angelic beings beside my bed. One of them said to me, "Servant of God, rise up and follow us," as He said that, I saw how my spirit came out of my body, and I followed them up in the air across the roof of my house. When I got out just above the roof of my house, I saw a heavenly vehicle that looked like a chariot made of Gold, Diamond and other precious stones. The Angel asked me to enter the spiritual chariot and when I entered, I realized that there were about 6 people already in the chariot, 3 were women, one was an Asian man and 2 of them were white, they were all already sitted in the chariot. From what I understood, these people were carried from around the world,  and I was the last one to be taken for that trip because when I got into the chariot, the Angel said that it was time for us to go to Heaven and we all in the chariot exclaimed with Joy - Hallelujah.
                  </p>
                  <p>
                    Then all of a sudden the chariot began ascending. What surprised me is that we did not disappear from the earth and appear in heaven, instead as we were ascending, we went through other spiritual worlds with strange beings, and while we were moving through the other worlds, we the sons of men in the chariot were waving at the beings in those worlds in amazement and great joy. This was just an unexplainable experience. We went through many worlds, with different atmospheres and creatures and then finally we came to a  place where there is a very large expanse or space and at the center of it there was an opening like a circle of Bright Clouds. At this point, I saw thousands and thousands of Demonic beings who were hovering around that spiritual opening, and I noticed that they were trying to enter but each time they came to the opening, they will be burned by the light flashing from the clouds, and they will quickly run behind with loud screams and screeching. When we got to the entrance the light of our spiritual chariot flashed on them and they ran out of the way.
                  </p>
                  <p>
                    When we entered into the clouds, we got into a TUNNEL, which was NARROW and FULL  of LIGHT, in this tunnel I realized that the light was so bright that everyone becomes transparent, nothing can be hidden there, because the deepest thoughts are all revealed by the light. When we were in the Tunnel, these Words of the Lord Jesus, came to My heart, as Recorded in Matthew 7:14:
                    <em>"Because strait is the gate, and narrow is the way, which leadeth unto life, and few there be that find it."</em>
                  </p>
                  <p>
                    At the End of the Tunnel we got to a HUGE Gate, which was made of Gold, Diamond and thousands of Different kinds of Precious stones whose brightness and color cannot be described by human words, when the Gate Opened up, we got into the Heavenly City of the Lord Jesus.
                  </p>
                  <p>
                    This was the highest and greatest part in the Journey. The Sight was so heavenly, so beautiful, so awesome, me and the other brethren began shedding tears of Joy.
                    When the chariot landed on a platform, I was the first to Jump out. I knelt down thanking the Lord Jesus for this privilege he granted me. I could also hear the other brethren praying and praising the Lord, when I got up from prayer, I said to myself I'd better run and see as many places as possible before its time to go back to the earth realm.
                  </p>
                  <p>
                    As we got into this heavenly City, With all the excitement in me, I completely forgot about the brethen I came with and I started walking around and looking at this glorious city, with glorious buildings. I kept greeting anyone I met on my way in excitement, I saw so many things that time will fail me to tell about, but while moving my attention was caught by a wonderful, glorious, beautiful house on a Hill. The building was extremely beautiful and it was surrounded by rainbows. While admiring the building, again I saw the Angel who had come to my room, and he led me to the building and when I got there, I saw the Lord Jesus. I was not permitted to go close to where he was or talk to him but I was permitted to see what He was doing.
                  </p>
                  <p>
                    I saw Him standing infront of a very large cloud that was like a screen, and he was writing things on these cloud or screen and when he will write, He will cut off the part and it will be in the likeness of a scroll and he will hand it to some beings who I believe were scribes because when they received the scroll on which the Lord had written, they took it to a hall and they will roll the scroll and write something on it. So the scroll had something written on it by the Heavenly scribes and something written in it by the Lord Jesus Himself and when these Elders (scribes) wrote on the scroll and rolled it, it was handed to Angels who took off in the form of lightning for the earth realm.
                  </p>
                  <p>
                    At this point, I enquired from one of the Elders who came to where I was about what is the Lord Jesus was doing?
                    And he said to me, "this is the hall where  the patterns of what was, what is and what will be is written and ordained by the hand of the Lord. What you see him write are the things that concerns his people to align them to the purpose of the Father."
                  </p>
                  <p>
                    And he Said to me " when the sons of men go astray, The Lord writes a new pattern for them inorder to bring them back into the will of the Father"
                  </p>
                  <p>
                    Then he said "this is the meaning of that which is written in the Holy scriptures, His mercies are new every morning, because despite the sins of the sons of men, the Lord in his Love writes a new pattern that is brought to them by his mercy in the womb of the morning, this new pattern can realign men to the will of the Father."
                  </p>
                  <p>
                    At this point, I remembered this scripture, John 5:17: <em>"But Jesus answered them, My Father worketh hitherto, and I work."</em>
                  </p>
                  <p>
                    One of the Elders came and handed a scroll to me that was sealed and he said to me, this is the will of the Father for you.
                  </p>
                  <p>
                    I was granted permission to see some scrolls and on one of them this is what I saw;
                    When this scroll was opened, I saw Images of what was written, behold a battle and I saw the Devil standing against Angel Michael who lifted his Sword and rebuked the Devil in the name of the Lord, and the Lord Jesus suddenly appeared behind Angel Michael and stretched His hand and a Blue Light came out of His hand and passing through the sword of Angel Michael and it struck the devil,  the light carried the devil out of Heaven and he fell with a great speed as lightning and he crashed in a dry land and when he fell he was naked, when he realized that he was naked, he clothe himself with darkness to cover his nakedness, this is the the mystery of how the Bearer of Light became the Prince of Darkness.
                  </p>
                  <p>
                    After this Encounter with the Lord Jesus and The Elders in the Hall of Witnesses, the Angel said to me, Come with me. And he carried me in the air, and we went to a place on a hill where there was a congregation, I and the Angel  stood afar, it seem permission was not granted for him to enter with me into the congregation. I saw a huge number of beings all dressed in white, the congregation was surrounded with seven rainbows, then I heard a sound of worship, so pure and heavenly. When the trumpets and heavenly instruments began playing and all the saints lifted their voices in one accord to worship the Father and the Lord Jesus and I noticed something strange as the worship began, every thing on the Hill, even the trees began producing melodies, so pure and excellent.
                  </p>
                  <p>
                    As the worship continued, when the saints lifted their hands, I saw a cloud covered them and rain began to fall on them but each drop of rain contained light and when it fell on them, their brightness increased and the trees on the hill produced a different kind of fruit.
                  </p>
                  <p>
                    And the Angel said to me "the saints who are still on earth must give themselves continually to worshipping the Father in Spirit and in Truth and the waters from the Fountain of Life shall refresh them, for this is not time to be weary, this is the time to watch and pray, for the day of the Lord is at hand, even the day ordained for the Lord to come and take his people unto himself is at hand.
                  </p>
                  <p>
                    Then the Angel asked me to Open the Scroll that the Elder had handed to me, and as i opened it I Saw a Message written in a heavenly language but as I Looked Part of it, was translated into My Spirit as <em>"Raise a Priest for God in Every Family, that there May raise Altars For God in Every Family and turn the Hearts of Men from the things of the World to the things of the Lord for the Day of the Lord is at hand"</em> and when I read it; a blue bright light came out of the words and entered me and moved through my body like electricity!
                  </p>
                  <p>
                    At this point the Angel told me "it is time to return to the earth realm," but this time around we did not enter the spiritual vehicle, he just held my hand and a light carried us and instantly I was back in my room. I woke up physically from sleep.
                  </p>
                  <p>
                    Glory be to God in the Highest, Jesus is Lord!
                  </p>
                  <p>
                    May it be done unto us according to the writing of He that Was, that is and That is to Come, The Alpha and Omega Our King and Lord, Jesus The Christ!
                  </p>
                  <p>
                    The Spirit Says Come, The Church Says Come! Come oh Lord Jesus!
                  </p>
                  <p>
                    The Priest of the Most High God
                  </p>
                </VisionSection>

                <VisionSection
                  id="the-vision-of-the-heavenly-market"
                  title="The Vision Of The Heavenly Market"
                  titleColor="from-yellow-400 to-yellow-600"
                  italicText="This vision came to me in the morning of the 23rd of Nissi (April), after intercession for the Saints, Pastors, and churches."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider15.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg">
                    After I saw the vision of the Rewarder on Mount Zion and the Heavenly Market, I now saw another vision. I saw a flock of sheep grazing upon green pastures, and suddenly, there appeared an assembly of beasts that looked like dogs, but in size they were bigger than lions. These dogs were coming with great speed to devour the sheep.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Then I saw something strange: the sheep began to mount up with wings as eagles and they began to fly. The sheep soared high above the reach of those beasts which looked like dogs. The sheep flew away and the beasts were in rage but could not hurt the sheep, for the sheep were out of their reach.
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add font-semibold">
                    "I have given my sheep the wings of eagles that they may soar and escape from the power of the dogs."
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    When I came out of the vision, the following scriptures came to my mind:
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    <strong>Revelation 12:14</strong> – "And to the woman were given two wings of a great eagle, that she might fly into the wilderness..."<br />
                    <strong>Psalm 22:16,20</strong> – "For dogs have compassed me... Deliver my soul from the sword; my darling from the power of the dog."
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    Then the vision ended and I praised the Lord for His grace through which I received these revelations.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    Dear Saints, put your trust in the Lord Jesus and through His Blood He shall deliver you from the power of the enemy and nothing shall by any means hurt you.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-bold">
                    Great Grace,<br />
                    The Priest of God
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    I pray for you, may the Lord Jesus grant you wings to escape out of the hand of every evil spirit that is after your health, your wealth, and your life... Amen!
                  </p>
                </VisionSection>

                <VisionSection
                  id="three-evil-beings-prophecy"
                  title="Prophecy About the 3 Evil Beings Released Against the Church and the World"
                  titleColor="from-pink-500 to-green-600"
                  italicText="A vision the Lord gave me while praying and seeking His face concerning the Church and the nations."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider16.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg">
                    The Lord graciously showed me a vision that unveiled the hidden plans of the kingdom of darkness against the Church. I saw men and women involved in demonic rituals—shedding human blood and engaging in perversions.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    As this was going on, a portal opened from the ground, and thick dark smoke emanated. From the portal came three great spiritual beings, each commanding millions of evil spirits.
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add font-semibold">
                    "Go forth into all the earth and establish the reign of wickedness... Make war against the saints and subdue them by every means possible... Be merciless... Steal, kill, and destroy—for these are the days of iniquity."
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    I saw a mighty being sitting on a dark throne with millions bowing to him, and he was called “the Goat-Man.” Still seeking the Lord about this mystery.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg">
                    The spirits moved across the earth like a dark whirlwind, leaving chaos, wickedness, and lawlessness in their path. But then I saw the Mighty Watchers of Heaven—angels of the Most High—prepared for battle.
                  </p>

                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add font-semibold">
                    "Let them who sleep, sleep no more... Consecrate yourselves unto the Lord in prayers and fasting. Give yourselves no rest until the Church becomes the Praise of the Earth."
                  </blockquote>

                  <p className="mb-6 leading-relaxed text-lg">
                    The Holy Spirit revealed that the three beings were three kinds of Nephilim:
                  </p>

                  <ul className="mb-6 list-disc list-inside text-lg leading-relaxed text-add">
                    <li><strong>Rephaims</strong> – Giants bringing destruction, oppression, affliction through sickness</li>
                    <li><strong>Zuzims</strong> – Roving creatures causing accidents, occultism, and immorality</li>
                    <li><strong>Emims</strong> – Terrors responsible for terrorism and war</li>
                  </ul>

                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    Dear Saints, be strengthened to pray! Angels cannot operate without your prayers. Let us depart from unrighteousness and give ourselves wholly to intercession.
                  </p>

                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    Now is not the time for doctrinal arguments—there is a great war in the spirit realm. Our prayers together will prevail.
                  </p>

                  <ul className="mb-6 list-disc list-inside text-lg leading-relaxed text-add">
                    <li>Pray for yourself</li>
                    <li>Pray for your family</li>
                    <li>Pray for the saints</li>
                    <li>Pray for the Church</li>
                    <li>Pray for the Nations</li>
                    <li>Pray that the Kingdom of God should come in power!</li>
                  </ul>

                  <p className="mb-6 leading-relaxed text-lg font-bold">
                    Arise, oh Saints, and Pray!
                  </p>
                </VisionSection>


                <VisionSection
                  id="sheep-with-eagle-wings"
                  title="The Vision of the Sheep That Mounted up with Wings"
                  titleColor="from-yellow-400 to-yellow-700"
                  italicText="This is the third vision in the morning of the 23rd of Nissi (April)..."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider17.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg">
                    After I saw the vision of the Rewarder on Mount Zion and the Heavenly Market...
                  </p>
                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add font-semibold">
                    "I have a given my sheep the wings of eagles that they may soar and escape from the power of the dogs"
                  </blockquote>
                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    I pray for You, May the Lord Jesus grant you wings to escape out of the hand of every Evil spirit...
                  </p>
                </VisionSection>

                <VisionSection
                  id="fruitful-tree-vision"
                  title="The Vision of the Great Fruitful Tree"
                  titleColor="from-green-400 to-green-700"
                  italicText="I was caught up in the Vision of God, and I saw a Mystery in the Realm of The Spirit..."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider18.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mb-6 leading-relaxed text-lg">
                    In the vision, I saw a hill and at the top of the hill was a great tree with great branches...
                  </p>
                  <blockquote className="mb-6 pl-6 border-l-4 border-border italic text-xl text-add font-semibold">
                    "Pray, for the strength of the flesh shall faint..."
                  </blockquote>
                  <p className="mb-6 leading-relaxed text-lg font-semibold">
                    Great Grace, <br />
                    The Priest of God.
                  </p>
                </VisionSection>

                <VisionSection
                  id="sheep-evil-birds-wild-cows-lion"
                  title="The Vision of the Sheep, the Evil Birds, the Wild Cows and the Lion Hidden in the Lamb"
                  titleColor="from-purple-300 to-indigo-500"
                  italicText="My spirit was caught up into the visions of God and I saw a great and terrible oracle from the Most High pertaining to the affairs of Men!"
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider19.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p>
                    I saw a Great field and there were many sheep that found pasture there and fed abundantly.
                    All of a sudden, I saw that there were wild beasts hiding in caves seeking to devour the sheep but each time they came for the sheep, the sheep will run away from them because the sheep saw the wild beasts from afar.
                  </p>
                  <p>
                    Then I saw something else. The beasts of the field made an alliance with the birds of the air and implored them to join them saying that if they join them to defeat the sheep, the birds of the air will feed on the fruits of the garden while the beasts feed on the flesh and blood of the sheep.
                  </p>
                  <p>
                    After this, I saw how the birds of the air gathered in thousands and came upon the sheep and began to pluck out their eyes. When they had plucked out their eyes, the sheep were all blind and started running all around the field. The beasts came out from their caves and attacked the sheep and overcame them and the sheep were scattered across the field and because the sheep had become blind they could no longer protect the garden.
                  </p>
                  <p>
                    So the birds of the air came down and fed on all the fruits of the field until it became a wilderness; extremely dry and harsh.
                  </p>
                  <p>
                    I saw Many of the sheep walking and looking for pastures but they could not find and the sheep were very bitter on account of their affliction and their thirst, for there was no pasture neither was there water.
                  </p>
                  <p>
                    The sheep wandered in the wilderness and behold I saw how wild beasts that looked like cows came from the mountains and began to attack, afflict and oppress the sheep. They trampled the sheep underfoot and began to pierce the sheep with their horns. Their horns drank the blood of the sheep.
                  </p>
                  <p>
                    The sheep wept and wept but there was no one to save them from the hands of the wild beasts who mercilessly destroyed them.
                  </p>
                  <p>
                    As the sheep began to cry, their voice reached to the heavens unto the Ears of the the God of All Creation and it was decreed that in the fulness of time a Saviour will be given to them!
                  </p>
                  <p>
                    And I saw how in the Midst of the sheep, a Great White Lamb without spot or Blemish was born. On its head there were seven horns, each of a different colour, texture and substance.
                  </p>
                  <p>
                    This Great Lamb moved with Meekness in the Midst of the sheep to gather them unto itself but the sheep did not heed to its voice.
                  </p>
                  <p>
                    All of a sudden, The Wild beasts attacked the Great Lamb, and in the Midst of the Battle the Lamb was slain for it was wounded on its side.
                  </p>
                  <p>
                    Out of the wound, water and blood flowed exceedingly like a river. It gushed out of its wound on the side and I saw that the sight of its blood was like a bright fire.
                  </p>
                  <p>
                    It came to Pass that some of the Wild Beasts gathered to drink the blood of the Lamb but they were destroyed because the blood burnt hot like a consuming fire.
                  </p>
                  <p>
                    When the other wild beasts saw this, they fled at the sight of the blood of the Lamb which pursued them and carried them away like a river and flood of fire!
                  </p>
                  <p>
                    Then I saw that the earth opened its mouth and drank the blood of the Lamb that was slain and when this happened there was a great earthquake.
                  </p>
                  <p>
                    When this earthquake occurred, I saw the strongholds of the wild beasts collapsing for they had made for themselves refuges in the midst of rocks on high mountains from which they came forth to terrify, afflict and oppress the Sheep!
                  </p>
                  <p>
                    All their refuges crumbled and I saw the waters that came out from the side of the Lamb become a fountain of water and it flowed all over the Wilderness and it became a fruitful garden.
                  </p>
                  <p>
                    The sheep were led to the waters and their eyes were washed in the waters and they began to see and they greatly rejoiced in the garden and were made to lie in the green pastures.
                  </p>
                  <p>
                    I saw that a Great White Cloud came down from heaven from the throne of God and covered the Lamb and then all of a sudden there were thunderings and when the cloud was lifted up I did not see the Lamb again but in its place I saw a Great Lion.
                  </p>
                  <p>
                    The Lion was Made of Fire. It was beautiful and peaceful yet at the same time terrible and Powerful and its eyes were flashes of lightning!
                  </p>
                  <p>
                    And at this the vision ceased, and I gave thanks to the Almighty God who is the Creator of All things for in His purpose, he ordained the Lamb to redeem his people and in His wisdom he hid the Lion in the Lamb to be the Judge of His People!
                  </p>
                  <p>Great Grace <br />The Priest of God</p>
                </VisionSection>

                <VisionSection
                  id="cloud-of-witnesses"
                  title="The Vision of The Cloud of Witnesses"
                  titleColor="from-yellow-500 to-yellow-400"
                  italicText="The visions of God came upon me while I laid in my bed and thoughts about heavenly things flooded my mind."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider20.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p>
                    A great presence came upon me and I became weak and then I was carried into this Supernatural occurrence whether it was in the body or out of the body I cannot tell but as the Lord Liveth and My Soul Liveth the vision is true and was Extremely Vivid and Real.
                  </p>
                  <p>
                    I heard a voice from heaven that spoke saying "there are Great men in the Spirit" the voice said this repeatedly, then suddenly it was like the roof of my room vanished because I could see the sky while laying in my bed, and I saw a portal opening in the sky and I saw beings riding on heavenly horses of fire.
                  </p>
                  <p>
                    The Horses were white and the men who rode on them were dressed in white with a red cloth on around their shoulders. After them I saw different kinds of heavenly beings, some had wings, some had no wings, the Cherubims too were amongst all of them and were riding on the clouds and coming towards my house.
                  </p>
                  <p>
                    As they came and stood above my roof, behold were the saints of old coming in a multitude, surprisingly when I saw any one of them, immediately in my heart I knew the name of the person. They came and entered my room and stood, all around my bed, Moses, Elijah, Samuel, David, Abraham, Deborah, Peter, Paul, John and so on.
                  </p>
                  <p>
                    The Saints whose accounts were recorded in the Old Testament stood on my left side, while those whose accounts were recorded in the New Testament were on my right side.
                  </p>
                  <p>
                    Then again I heard a voice but this time it sounded like many waters and thundered saying "These are Great Men in the Spirit, you are called to be amongst them why are You Sleeping?"
                  </p>
                  <p>
                    When He said that, I was still on the bed paralysed by the sight of the heavenly beings, and all of them turned and looked at me and their eyes were like Rays of Lights piercing my soul, as I looked at them, through their eyes I started seeing all the great deeds they wrought for the Lord in a moment of time.
                  </p>
                  <p>
                    It is unexplainable how I look at them and see years of their walk with God just in a moment of time, then tears began to flow down my eyes and suddenly I saw them no more, and I realized I was alone in my room.
                  </p>
                  <p>
                    Today I announce the Cry of the Spirit unto You; "There are Great Men in the Spirit and you are called to be amongst them, why are you sleeping?"
                  </p>
                  <p>
                    The kingdom of God needs you, your generation needs to see God through you, why are you sleeping?
                  </p>
                  <p>
                    Awake o army of God Awake and the Light of Christ will shine upon you!
                  </p>
                  <p>
                    Awake to your Prophetic Assignment, Forget about your past, deny yourself the pleasures of the flesh and become part of those who will advance the kingdom of God in this generation by bearing the burdens of God!
                  </p>
                  <p>
                    Say this prayer with me:
                  </p>
                  <p>
                    Oh Holy Spirit, awaken me and enlist me in the Rank of Witnesses unto Christ.
                  </p>
                </VisionSection>

                <VisionSection
                  id="visions-2024-point-1"
                  title="Visions of God 2024 - Point 1"
                  titleColor="from-red-600 to-pink-600"
                  italicText="For Cameroon 2024 shall be the Year of the Beginning of Change."
                >
                  <p>
                    I saw a strong wind blow from the four Corners of Cameroon and behold there was a great shaking and I saw they that sat on thrones were overthrown, those who were planted were uprooted, those who were exalted were cast down.
                  </p>
                  <p>
                    I saw in the visions of God, there was a great battle between the old and the young and though the old sought to appease the young with many flatteries, the young refused to be appeased and then the old shall move themselves to threaten the youths, but the youths shall not be silenced,
                  </p>
                  <p>
                    and then when the old saw that they could not prevail against the youths, they sought to make amends but it shall all be in vain.
                  </p>
                  <p>
                    The youths shall strife with wisdom and strength until their desire is fulfilled and it shall be.
                  </p>
                </VisionSection>

                <VisionSection
                  id="visions-2024-point-2"
                  title="Visions of God 2024 - Point 2"
                  titleColor="from-green-600 to-emerald-500"
                  italicText="The fire in The Northwest and Southwest Regions of Cameroon has been quenched in the Realm of the Spirit."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider21.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p>
                    I saw in the Visions of God, a log of wood Burning in a fire and I saw an outstretched Hand taking it out of the Fire, when it was taken out of the fire about 1/3 of the wood had already been destroyed and I saw the breadth of God of come upon the Wood and the Fire was put off and when the fire was put off it,
                  </p>
                  <p>
                    the wood was still red hot for a while but after a while it became just dark like charcoal and then I saw rain falling upon the wood and then it became fresh and out of it came forth leaves and fruits.
                  </p>
                  <p>
                    This is what I saw concerning the crisis in the Northwest and South West, I saw the fire put off by the breadth of God, and though some will try to rekindle the fire, the efforts shall all be in vain for the time allotted to that crisis has been completed.
                  </p>
                </VisionSection>

                <VisionSection
                  id="visions-2024-point-3"
                  title="Visions of God 2024 - Point 3"
                  titleColor="from-yellow-600 to-yellow-400"
                  italicText="I saw in the Visions of God 3 rams fighting..."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider22.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p>
                    I saw in the Visions of God 3 rams fighting, they were 2 small rams facing a big ram, each ram having its horns, and I saw them locking their horns against one another but the two small rams could not prevail against the Big ram because their horns were small and then I saw something strange the big ram opened its mouth and out of it came forth a dark smoke and when the other 2 rams inhaled if they became as though intoxicated and they 2 rams turned and began to fight one another.
                  </p>
                  <p>
                    And the big ram left them fighting themselves and when and lay down under a great Tree and was watching them fight, then something strange happened, I Saw the Tree that was giving shade to the Big ram suddenly a great branch from the tree broke and fell on the Ram and its great horn was broken off, and the horn was scattered into 3.
                  </p>
                  <p>
                    When this happened, the Great Ram saw that its strength was scattered it sought to make peace with the other 2 rams but they turned and fought it and pursued it till it was utterly weakened and overpowered.
                  </p>
                </VisionSection>

                <VisionSection
                  id="visions-2024-point-4"
                  title="Visions of God 2024 - Point 4"
                  titleColor="from-blue-600 to-cyan-500"
                  italicText="The agricultural sector will be the strength of the economy..."
                >
                  <div className="w-full h-[350px] bg-gray-100 mb-5 flex items-center justify-center">
                    <img
                      src="images/watchTowerImageSlider/watchImageSlider23.jpg"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p>
                    The agricultural sector will be the strength of the economy and a lot of money will be made from the exportation of Agricultural products.
                  </p>
                  <p>
                    In the visions of God, I saw a great rain come upon the land and I saw that the fields were very green, and strangely the fruits were of extraordinary sizes.
                  </p>
                  <p>
                    Nevertheless, there is a need for caution and wisdom for those in agriculture and animal husbandry, for I saw a great swarm of locusts invade the Land from the 8th month of the year and some of the green pastures were turned to dry lands.
                  </p>
                  <p>
                    So those concerned in this sector must employ every strategy to counter a disease that will affect animals and plagues that will affect crops.
                  </p>
                </VisionSection>

                <VisionSection
                  id="visions-2024-point-5"
                  title="Visions of God 2024 - Point 5"
                  titleColor="from-purple-700 to-pink-600"
                  italicText="The Lord has declared unto the Church in Cameroon that 2024 is the year of Visitation..."
                >
                  <p>
                    The Lord has declared unto the Church in Cameroon that 2024 is the year of Visitation, for a New Dawn from Heaven is broken upon her. The Lord has caused His face to shine upon His church in Cameroon.
                  </p>
                  <p>
                    In the visions of God, I heard the decree "Wealth, Wealth, Wealth, let it flow into the church and let there be an overflow into communities!" From this year 2024, the church of God in Cameroon shall be lifted out of the dunghill and shall inherit a glorious throne.
                  </p>
                  <p>
                    In the visions of God, I heard a little voice speaking as a whisper but then it began to increase in volume until it became as thunder that cannot be ignored, and the Lord said "He shall cause the Voice of the Church in Cameroon to be heard and even the government shall seek counsel from the Church and she shall no longer be despised even amongst the Nations."
                  </p>
                  <p>
                    And while I was still looking at the visions of God, I saw a fire come from Heaven, I saw a bush being burned but was not consumed and the sight of it was a wonder to behold.
                  </p>
                  <p>
                    And I saw people and Kings come out of every nation to come and see this bush and I saw that this bush was the Flag of Cameroon, and then out of the Bush I saw flames of fire shooting out like lightning bolts all over, and I understood by the intelligence of the Spirit that the fire was the fire of the Prophetic.
                  </p>
                  <p>
                    Thus saith the Spirit "Out of Cameroon shall emerge, Prophets who shall be mighty in the word and works, and they shall be carried across the earth to turn the hearts of many from the world unto the Lord by the Spirit of Prophecy and this is the sign by which they shall be known, they shall walk in righteousness and shall not compromise their gifts of the Spirit for the pleasures of the flesh, they shall be holy unto the Lord and whenever or wherever they minister many shall be purified."
                  </p>
                </VisionSection>

                <VisionSection
                  id="visions-2-church"
                  title="IN THE VISIONS OF GOD 2: Prophetic Word for The Church"
                  titleColor="from-indigo-200 to-indigo-500"
                  italicText="The Lord has decreed this Year to the Body of Christ as the Year of Preparation and Quickening."
                >
                  <p>
                    1. The Lord has decreed this Year to the Body of Christ as the Year of Preparation and Quickening, The Saints are to be prepared through the Ministry of the Word and are to be quickened through the Ministry of Prayer to know and Do The Will of God and fulfill His Purpose, There must be a consecration of the flesh in order to be aligned to the desires of the Spirit.
                  </p>
                  <p>
                    In the Visions of God, I saw a Great war in The Spirit and I saw a red dragon from whose mouth came forth water, and each time it opened its mouth the water came forth to carry away the saints of God, and the Spirit of the Lord revealed to me that the water from the Mouth of the dragon is the Spirit of Deception, and Many of those who have not been rooted in Christ through the knowledge of the doctrine of Christ shall give heed to seducing spirits and shall begin to obey the doctrine of the devil and this shall cause them to shipwreck their faith.
                  </p>

                  <p>
                    2. In the Visions of God, the Lord appeared to Me and his Angel gave me a message thus “You are degrading Jesus when You walk in unbelief, ingratitude, and unrighteousness”! The Father is Calling the Church to Magnify the Lord Jesus by walking by faith, working righteousness, and continually giving thanks to Him for this Is His Perfect will for the Church of Christ.
                  </p>

                  <p>
                    3. In the Visions of God, I heard this “Jesus is coming very soon but the number of women prepared for his coming are very very few”. The Lord is revealing that emphasis be placed on Ministering to women. It was also revealed to me that the attention of Spirits has been shifted to women because they will be instruments to cause the rising or downfall of Many People, nations, and Kings, in this regard the Lord commands that Prayers be made for all women, conferences be organized to teach women to know the Will of God and to do it.
                  </p>

                  <p>
                    4. The enemy has released the Spirit of Corruption and perversion specifically to infiltrate the children's departments of churches. In the Visions of God, I saw strange children from the water who were assigned to children's departments in churches and they were filled with Satanic and sensual wisdom to lure children into despicable Immorality, stubbornness, lying and stealing.
                  </p>
                  <p>
                    Thus every church must pay more attention to the children's department, henceforth, carry them along in all Spiritual activities even preaching, and let those who will pastor those departments be carefully chosen through the Wisdom of the Spirit.
                  </p>

                  <p>
                    5. The Lord said that this Year, He will make a difference between those who serve him and those who do not, they who serve God shall spend the days of this year in the pleasures of God and they shall prosper in all things this Year.
                  </p>

                  <p>
                    6. In the Visions of God, I saw a thick dark cloud, and I heard thunder rumblings from within it then all of a sudden, I saw millions of lightning bolts break forth and were scattered in all directions.
                  </p>
                  <p>
                    This year shall be the Year of the emergence of the hidden ones, the Men and Women who have been mentored by the Holy Spirit in the secret Place, their light shall break forth speedily, and all those who have been waiting upon the Lord for years, this year shall be their year of showing forth.
                  </p>

                  <p>
                    7. In the Visions of God, I saw the Heavens opened and I saw a Mighty outpouring of Showers from on High, and The decree of the Lord unto the rain was thus; Refresh the Weary, Revive the Faint and Renew the face of My Church,” this year, the Lord Will visit all those who have been waiting upon him and shall grant their requests according to His will,
                  </p>
                  <p>
                    I can authoritatively say that this year many stubborn problems will be solved through the intervention of the Great God.
                  </p>

                  <p>
                    8. The Lord Said to me “Herod has demanded the Head of John, James and Peter.” When I heard this, I saw in the visions of God that the Devil is stirring the hearts of men and women in government so that they may stretch their hands and afflict the sheep of God by cutting off the shepherds.
                  </p>
                  <p>
                    Governments will sign decrees against the Church and some of the decrees will be aimed at controlling the wealth and activities of some major Pastors and I saw that many will receive this news with gladness and even some Christians but unknown to them this is all a strategy to cut off the heads of churches, they will seek to imprison or even kill many and I even saw how in a certain Church the government forcefully removed the General Overseer and founder of a Ministry and installed someone else.
                  </p>
                  <p>
                    In this vision, I understood that the governments took advantage of the disputes in churches brought to Courts, so I strongly counsel by the grace of God given to me, let Christians refrain from taking the issues that concern the church of God to the courts of men, even as scriptures have instructed, let the matters of the Church be judged by the Elders of the Body of Christ in that region or nation (1 Corinthians 6:1-10).
                  </p>
                  <p>
                    Nevertheless, the Lord Instructs His servants to be faithful to him even unto the death and also the Lord commands Christians to pray for the Pastors daily that they may be delivered from wicked and unreasonable Men.
                  </p>

                  <p>
                    9. The Devil will change the weapons employed to fight the Faith, the battle shall no longer be on terms of Magic but on terms of Logic, and due to great breakthroughs in technology and in Medical Science, he will seek to turn Many away from the Faith with strong arguments based on Logic and Worldly philosophies.
                  </p>

                  <p>
                    10. This Year shall be a year of restoration for many who hath backslidden. In the Visions of God, I saw the hand of a Potter making vessels fit for His Use, and though some were marred, he broke them and made them again as it seemed good to use.
                  </p>
                  <p>
                    Now something I realize even the vessels whom I thought had become useless after the Touch of the Potter became useful again.
                  </p>
                  <p>
                    This year the Lord has stretched his hand to those who had fallen and He desires to restore them to profitable service for the kingdom but this will only be when they submit themselves to the Dealings of God through which they will be broken and re-designed in the image of Christ.
                  </p>
                </VisionSection>

                <VisionSection
                  id="visions-3-world"
                  title="IN THE VISIONS OF GOD 3: For the World"
                  titleColor="from-red-700 to-orange-600"
                  italicText="The Lord Said to me that 2024 is the Year of the Beginning of Sorrows."
                >
                  <p>
                    1. The Lord Said to me that 2024 is the Year of the Beginning of Sorrows, for the great woman has entered into her travail and she shall weep and Lament because of her labor pains.
                  </p>

                  <p>
                    2. In the visions of God I saw a beast go through Many nations and wherever it went the place was left in fire and blood ( I will give the Prophecies mentioning the nations in which I saw this happen for now I will give myself to intercession to see if it can be averted but if not, then I will say them as a testimony to the Nations that sovereign knows all the ways of Men and he deals with them according to their works).
                  </p>

                  <p>
                    3. In the Visions of God I saw a Flying Sword, and this Sword was released against the Kings, and Men of influence. There will be strange diseases and plagues that will befall the Mighty and the rich, which will cause Many of them to humble themselves and seek the Face of the Lord because they will be unable to find help through their Money.
                  </p>

                  <p>
                    4. This year shall mark the beginning of the dethrone of one of the ‘gods’ of this World known as Mammon. I Saw in the Visions of God a highly exalted Being dressed in the most expensive clothes and laced with all kinds of jewelry, I saw an earthquake and his throne broke into Two and He fell Into the dunghill,
                  </p>
                  <p>
                    This Year Money Shall begin to fail, and also nations will begin moving from physical money to virtual Money to exert more control on the wealth of People and the nations will take Money from the wealthy of nations to invest in Purchasing weapons of war.
                  </p>

                  <p>
                    5. In the Visions of God I saw people walking on the road and a wind came from the wilderness and began to slay them and the people began to suddenly fall and die. I saw that there will be 3 extremely deadly plagues that will hit the world this year, One will cause incurable boils on the flesh, one will be a virus that destroys internal organs the deadliest shall be one that will be like a fever (More details on where and when this will start will be given on later after intercessions).
                  </p>

                  <p>
                    6. In the visions of God, I saw Great shakings, especially in Europe and Asia and I saw the earth open her mouth and after that, I saw entire cities swallowed. There will be terrible earthquakes that are ordained to swallow humans and properties!
                  </p>

                  <p>
                    7. I saw a Might Angel Descend from heaven and took a Key that was hidden in the moon and he came and opened the gates of Muslim-inclined Nations, and I saw a great multitude of Muslims turning unto the Lord from the Nations of the World,
                  </p>
                  <p>
                    I saw one whose is a very great and respected Muslim cleric turned to the Lord by an encounter with the Angel of the Lord and His conversion will shake the Muslim world and will cause them to adopt to stricter measures against conversation to Christianity but yet the more they shall afflict them, the More Christians shall Multiply.
                  </p>

                  <p>
                    8. In the visions of God, I saw the cryptocurrency business do extremely well but after a while, some Cryptocurrencies crashed terribly. So, for those in cryptocurrency spaces, pray and seek guidance from the Spirit of God on which one to invest in, and when you begin to make profits withdraw your money and invest in Real Estate.
                  </p>
                  <p>
                    This is because the Great Profits that will be made through Cryptocurrency are well-crafted strategies to lure men to invest their all and then when it crashes they shall become indebted and then made to enter into certain dark covenants through which they will be given access to make great wealth through cryptocurrency at the exchange of their souls.
                  </p>
                </VisionSection>

              </section>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

const VisionSection = ({ id, title, titleColor, italicText, children }) => (
  <div
    id={id}
    className="my-6 p-1 shadow-theme bg-card"
    style={{ animation: "fadeIn 1.5s ease forwards" }}
  >
    <h1
      className={`text-2xl text-primary font-extrabold mb-8 border-b-4 border-border ${titleColor} text-center ${titleColor} select-none`}
    >
      {title}
    </h1>
    {italicText && (
      <p className="mb-6 italic text-extra font-bold tracking-wide drop-shadow-md">
        {italicText}
      </p>
    )}
    <div className="prose prose-invert max-w-none text-text font-medium">
      {children}
    </div>
  </div>
);

export default WatchTower;
